import useUrlAnnonceCommentaire from 'hooks/useUrlAnnonceCommentaire'
import { useEffect } from 'react'
import { Status as StatusFavoris } from 'redux/features/favoris/slice'
import cn from 'classnames'
import { Button } from 'react-bootstrap'
import ModalCommentaire from '../ModalCommentaire'
import ModalUrlAnnonce from '../ModalUrlAnnonce'
import s from './BtnModalUrlAnnonceCommentaire.module.scss'

interface Props {
  uid: string
}

const BtnModalUrlAnnonceCommentaire = ({ uid }: Props): JSX.Element => {
  const {
    urlAnnonce,
    commentaire,
    statusCommentaire,
    statusUrlAnnonce,
    showModalUrlAnnonce,
    showModalCommentaire,
    updateCommentaire,
    updateUrlAnnonce,
    toggleModalCommentaire,
    toggleModalUrlAnnonce,
    idleUrlAnnonce,
    idleCommentaire,
  } = useUrlAnnonceCommentaire(uid)

  const handleSubmitUrlAnnonce = (newUrlAnnonce: string | null) => {
    updateUrlAnnonce(newUrlAnnonce)
  }

  const handleSubmitCommentaire = (newCommentaire: string | null) => {
    updateCommentaire(newCommentaire)
  }

  const handleVoirAnnonceClick = () => {
    window.open(urlAnnonce, '_blank')
  }

  const handlePass = () => {
    toggleModalUrlAnnonce(false)
    toggleModalCommentaire(true)
  }

  useEffect(() => {
    if (statusUrlAnnonce === StatusFavoris.Succeeded) {
      toggleModalUrlAnnonce(false)
      idleUrlAnnonce()
      toggleModalCommentaire(true)
    }
  }, [
    statusUrlAnnonce,
    toggleModalUrlAnnonce,
    idleUrlAnnonce,
    toggleModalCommentaire,
  ])

  useEffect(() => {
    if (statusCommentaire === StatusFavoris.Succeeded) {
      toggleModalCommentaire(false)
      idleCommentaire()
    }
  }, [statusCommentaire, toggleModalCommentaire, idleCommentaire])

  return (
    <>
      <Button
        className={cn('btn-bind-annonce', s.btnBindAnnonce)}
        variant="outline-secondary"
        onClick={() => toggleModalUrlAnnonce()}
      >
        {!(urlAnnonce || commentaire) && 'Associer annonce / commentaire'}
        {(urlAnnonce || commentaire) && 'Modifier annonce / commentaire'}
      </Button>
      {urlAnnonce && (
        <Button
          title={urlAnnonce}
          className={cn('btn-annonce', s.btnAnnonce)}
          variant="outline-primary"
          onClick={handleVoirAnnonceClick}
        >
          Voir l&apos;annonce
        </Button>
      )}
      <ModalUrlAnnonce
        uid={uid}
        urlAnnonce={urlAnnonce}
        show={showModalUrlAnnonce}
        onHide={() => toggleModalUrlAnnonce()}
        onSubmit={handleSubmitUrlAnnonce}
        onPass={handlePass}
      />
      <ModalCommentaire
        uid={uid}
        commentaire={commentaire}
        show={showModalCommentaire}
        onHide={() => toggleModalCommentaire()}
        onSubmit={handleSubmitCommentaire}
      />
    </>
  )
}

export default BtnModalUrlAnnonceCommentaire
